import {
  HEADER_CELL_BORDER_BOTTOM,
  PINNED_RIGHT_EDGE_LINE_STYLE,
} from '../../../../constants/borderStyles';

export type ActionHeaderCellProps = {
  actionColumnWidth: number;
  heightPx: number;
  /** Sticky top offset in px. 0 when no group header row is shown; GROUP_HEADER_ROW_HEIGHT when visible. */
  stickyTop: number;
};

/**
 * Empty sticky header cell for the action column.
 * Pinned right at offset 0, same z-index as pinned header cells.
 */
export function ActionHeaderCell(props: ActionHeaderCellProps) {
  return (
    <th
      className="p-0 border-0 bg-gray-50"
      aria-hidden
      style={{
        position: 'sticky',
        top: props.stickyTop,
        right: 0,
        zIndex: 'var(--z-content-loader)',
        width: props.actionColumnWidth,
        maxWidth: props.actionColumnWidth,
        height: props.heightPx,
        ...HEADER_CELL_BORDER_BOTTOM,
      }}
    >
      <span style={PINNED_RIGHT_EDGE_LINE_STYLE} />
    </th>
  );
}
